import * as React from 'react';
import { ButtonType, CustomButton, CustomSubmitButton } from "soprasteria-ui-library";
import { IOrthodonticLkgCfPatientExtensionCreate } from '../../../models/IOrthodonticLkgCfPatientExtension';
import { useHistory } from 'react-router';

interface IOrthodonticLkgCfPatientExtensionFooterButtons {
    canCreateOrthodonticLkgCfPatientExtension: boolean;
    sendOrthodonticLkgCfPatientExtensionRequest: (data: IOrthodonticLkgCfPatientExtensionCreate) => void;
    isSendingOrthodonticLkgCfPatientExtensionRequest: boolean;
    canMakeDecision: boolean;
    setIsDecisionReasonRequired: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OrthodonticLkgCfPatientExtensionFooterButtons: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionFooterButtons> = ({ canCreateOrthodonticLkgCfPatientExtension, sendOrthodonticLkgCfPatientExtensionRequest, isSendingOrthodonticLkgCfPatientExtensionRequest, canMakeDecision, setIsDecisionReasonRequired }) => {

    const history = useHistory();

    return (
        <>
            <div className="row">
                <div className="col-6 text-left">
                    <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                </div>
                <div className="col-6 text-right">
                    {
                        canCreateOrthodonticLkgCfPatientExtension ?
                            <CustomSubmitButton isLoading={isSendingOrthodonticLkgCfPatientExtensionRequest} onButtonSubmit={sendOrthodonticLkgCfPatientExtensionRequest}>Skicka ansökan</CustomSubmitButton>
                            : null
                    }
                    {
                        canMakeDecision ?
                            <>
                                <CustomButton buttonType={ButtonType.deleteAlt} buttonText="Avslå ansökan" data-target="#orthodontic-lkgcf-patient-extension-reject-modal" data-toggle="modal" onClick={() => setIsDecisionReasonRequired(true)} />
                                <CustomButton buttonType={ButtonType.success} buttonText="Godkänn ansökan" data-target="#orthodontic-lkgcf-patient-extension-approve-modal" data-toggle="modal" onClick={() => setIsDecisionReasonRequired(false)} />
                            </>
                            : null
                    }
                </div>
            </div>
        </>
    )
}